module.exports = __webpack_public_path__ + "img/zc-2022-CIS.71e08eb3.jpg";